import React from "react";

// 경량 라우트 전환 스켈레톤 — webview 부담 최소화(단순 pulse, 큰 자산/무거운 애니메이션 없음).
// 페이지 청크 로드 동안 "빈 화면 멈춤" 대신 즉시 표시.
export default function RouteFallback() {
  return (
    <div className="min-h-screen bg-[#F0F3F5] dark:bg-[#13161c] max-w-md mx-auto" data-testid="route-fallback">
      <div className="h-28 bg-gray-200 dark:bg-gray-800 animate-pulse" />
      <div className="px-5 -mt-5 relative z-10">
        <div className="h-20 rounded-2xl bg-white dark:bg-gray-900 border border-gray-100 dark:border-gray-800 shadow-sm animate-pulse" />
      </div>
      <div className="px-5 mt-5 space-y-3">
        <div className="h-24 rounded-2xl bg-gray-200 dark:bg-gray-800 animate-pulse" />
        <div className="h-16 rounded-2xl bg-gray-200 dark:bg-gray-800 animate-pulse" />
        <div className="h-16 rounded-2xl bg-gray-200 dark:bg-gray-800 animate-pulse" />
      </div>
    </div>
  );
}
